export default __webpack_public_path__ + "static/hero-video-70f892ec124021991afc164d18799862.mp4";